import {BaseAppModel} from "./AppModel";
import DataSpec, {DataType} from '@/module/thing/DataSpec';
import ParamProxy from "@/module/thing/ParamProxy";
import _ from "lodash";
import NotifyTemplate from "@/module/notify/NotifyTemplate";

export interface ThingModelAware {
    properties: Array<Property>;
    events: Array<Event>;
    services: Array<Service>;
}

export abstract class BaseThingModelAware implements ThingModelAware {
    properties: Array<Property> = []
    events: Array<Event> = []
    services: Array<Service> = []

    copy(another: ThingModelAware): void {
        this.properties = another.properties
        this.events = another.events
        this.services = another.services
    }

    get funs(): Array<Fun> {
        return _.merge(Array<Fun>(), this.events, this.services)
    }
}

export class StdThingModelAware extends BaseThingModelAware {
}

export default class ThingModel extends BaseAppModel<ThingModel> implements ThingModelAware {
    productId = -1
    properties: Array<Property> = []
    events: Array<Event> = []
    services: Array<Service> = []

    get funs(): Array<Fun> {
        return _.merge(Array<Fun>(), this.events, this.services)
    }

    copy(aware: ThingModelAware): void {
        this.properties = aware.properties;
        this.events = aware.events;
        this.services = aware.services;
    }
}

export class Tsl extends BaseThingModelAware {
}

export abstract class Resource {
    identifier!: string
    name!: string
    description: string | undefined

    mode!: Mode

    resourceType!: ResourceType

    version!: string
    required!: boolean
}

export class Property extends Resource {
    rwFlag!: RwFlag
    dataType!: DataType
    dataSpecs!: Array<DataSpec>
    default!: string | undefined
}

export interface HasFunId {
    funId: number;
}

export type Fun = Resource & HasFunId

export enum EventType {
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR"
}

export class EventNotify {
    /**
     * 是否通知用户
     */
    notifyUser = false
    templates = new Array<NotifyTemplate>()
}

export class EventMessageConfig {
    saveCondition?: string = undefined
}

export class Event extends Resource implements Fun {
    type!: EventType
    outputParamProxies!: Array<ParamProxy>
    funId!: number
    notify: EventNotify = new EventNotify()
    messageConfig: EventMessageConfig = new EventMessageConfig()
}

export class Service extends Resource implements Fun {
    inputParamProxies!: Array<ParamProxy>
    outputParamProxies!: Array<ParamProxy>
    funId!: number
}

export enum Mode {
    STD = "STD",
    CUSTOM = "CUSTOM"
}

export enum ResourceType {
    PROPERTY = "PROPERTY",
    EVENT = "EVENT",
    SERVICE = "SERVICE"
}

export const resourceTypeZh =
    {
        PROPERTY: "属性",
        EVENT: "事件",
        SERVICE: "服务"
    }

export enum RwFlag {
    READ_ONLY = "READ_ONLY",
    READ_WRITE = "READ_WRITE"
}
